import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';
import { WOW } from 'wowjs';
import 'animate.css';

export default function Contact() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    phone: '',
    message: '',
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const wow = new WOW({ mobile: false, live: true });
    wow.init();
  }, []);

  const validate = () => {
    const errs = {};
    if (!form.name.trim()) errs.name = 'Name is required';
    if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email))
      errs.email = 'Valid email is required';
    if (!form.subject.trim()) errs.subject = 'Subject is required';
    if (!form.message.trim()) errs.message = 'Message is required';
    return errs;
  };

  const handle = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: '' });
  };

  const submit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
      setForm({ name: '', email: '', subject: '', phone: '', message: '' });
      setTimeout(() => setSubmitted(false), 6000);
    }, 1000);
  };

  return (
    <div className="page-wrapper">
      <Preloader />
      <Header style="two" />
      <PageTitle title="Contact Us" breadcrumbs={[{ label: 'Contact' }]} />

      <section className="contact-details">
        <div className="container pt-110 pb-70">
          <div className="row">
            <div className="col-xl-7 col-lg-6">
              <div className="sec-title">
                <span className="sub-title before-none">Send us email</span>
                <h2>Feel free to write</h2>
              </div>

              {submitted && (
                <div className="alert alert-success" role="alert">
                  Thank you! Your message has been sent successfully.
                </div>
              )}

              <form id="contact_form" onSubmit={submit} noValidate>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="mb-3">
                      <input
                        name="name"
                        className={`form-control${errors.name ? ' is-invalid' : ''}`}
                        type="text"
                        placeholder="Enter Name"
                        value={form.name}
                        onChange={handle}
                      />
                      {errors.name && (
                        <div className="invalid-feedback">{errors.name}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="mb-3">
                      <input
                        name="email"
                        className={`form-control${errors.email ? ' is-invalid' : ''}`}
                        type="email"
                        placeholder="Enter Email"
                        value={form.email}
                        onChange={handle}
                      />
                      {errors.email && (
                        <div className="invalid-feedback">{errors.email}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="mb-3">
                      <input
                        name="subject"
                        className={`form-control${errors.subject ? ' is-invalid' : ''}`}
                        type="text"
                        placeholder="Enter Subject"
                        value={form.subject}
                        onChange={handle}
                      />
                      {errors.subject && (
                        <div className="invalid-feedback">{errors.subject}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="mb-3">
                      <input
                        name="phone"
                        className="form-control"
                        type="text"
                        placeholder="Enter Phone"
                        value={form.phone}
                        onChange={handle}
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <textarea
                    name="message"
                    className={`form-control${errors.message ? ' is-invalid' : ''}`}
                    rows="7"
                    placeholder="Enter Message"
                    value={form.message}
                    onChange={handle}
                  ></textarea>
                  {errors.message && (
                    <div className="invalid-feedback">{errors.message}</div>
                  )}
                </div>
                <div className="mb-5">
                  <button
                    type="submit"
                    className="theme-btn btn-style-one"
                    disabled={loading}
                  >
                    <span className="btn-title">
                      {loading ? 'Please wait...' : 'Send message'}
                    </span>
                  </button>
                  <button
                    type="button"
                    className="theme-btn btn-style-one bg-theme-color5 ms-2"
                    onClick={() =>
                      setForm({
                        name: '',
                        email: '',
                        subject: '',
                        phone: '',
                        message: '',
                      })
                    }
                  >
                    <span className="btn-title">Reset</span>
                  </button>
                </div>
              </form>
            </div>

            <div className="col-xl-5 col-lg-6">
              <div className="contact-details__right">
                <div className="sec-title">
                  <span className="sub-title before-none">Need any help?</span>
                  <h2>Get in touch with us</h2>
                  <div className="text">
                    Lorem ipsum is simply free text available dolor sit amet
                    consectetur notted adipisicing elit sed do eiusmod tempor
                    incididunt simply dolore magna.
                  </div>
                </div>
                <ul className="list-unstyled contact-details__info">
                  <li>
                    <div className="icon">
                      <span className="fal fa-phone"></span>
                    </div>
                    <div className="text">
                      <h6 className="mb-1">Have any question?</h6>
                      <a href="tel:+920209850">
                        <span>Free</span> +92 (020)-9850
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="fal fa-envelope"></span>
                    </div>
                    <div className="text">
                      <h6 className="mb-1">Write email</h6>
                      {/* <a href="mailto:info@hoteler.com">info@hoteler.com</a> */}
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="fal fa-location-arrow"></span>
                    </div>
                    <div className="text">
                      <h6 className="mb-1">Visit anytime</h6>
                      <span>66 Brooklyn Golden Street. New York</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map */}
      <section className="map-section">
        <iframe
          className="map w-100"
          title="Google Map"
          src="https://maps.google.com/maps?width=100%25&height=600&hl=en&q=1%20Grafton%20Street,%20Dublin,%20Ireland&t=&z=14&ie=UTF8&iwloc=B&output=embed"
          style={{ height: '450px', border: 0 }}
          allowFullScreen
          loading="lazy"
        ></iframe>
      </section>

      <Footer />
      <ScrollToTop />
    </div>
  );
}
